import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { HeartHandshake, ArrowLeft } from "lucide-react";
import MomentBanner from "@/components/MomentBanner";

export default function StopScreen({ payload, onContinue }) {
  const reroute = payload?.reroute || {};
  const isPrereq = reroute.type === "prerequisite";
  const moment = payload?.mitraa_moment;
  const momentQueue = payload?.mitraa_moment_queue || [];
  
  return (
    <div className="fade-up max-w-2xl mx-auto" data-testid="stop-screen">
      {/* Gamification Moment Banners */}
      <MomentBanner moment={moment} className="mb-4" />
      {momentQueue.map((queuedMoment, idx) => (
        <MomentBanner 
          key={`queued-${queuedMoment.moment_id || idx}`} 
          moment={queuedMoment} 
          className="mb-4" 
        />
      ))}
      
      <Card className="rounded-3xl p-10 mit-shadow border-amber-200 bg-amber-50 text-center">
        <div className="w-24 h-24 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-5">
          <HeartHandshake className="w-12 h-12 text-amber-600" />
        </div>
        <h2 className="font-display text-3xl font-bold text-amber-900 mb-3" data-testid="stop-headline">
          Take a breath — we've got you.
        </h2>
        <p className="text-slate-700 text-lg mb-3" data-testid="stop-message">
          {payload?.message}
        </p>
        <p className="text-slate-700 text-lg mb-6" data-testid="stop-recommendation">
          Go through this topic once more with your teacher or in your book — you'll get it next time!
        </p>

        <div className="bg-white rounded-2xl p-4 mb-6 text-left text-slate-700 border border-amber-100">
          {isPrereq ? (
            <p data-testid="stop-reroute-prereq">
              Back on the dashboard, tap <strong>Revisit</strong> on <strong>{reroute.sub_topic}</strong> to build on the basics first.
            </p>
          ) : (
            <p data-testid="stop-reroute-recap">
              Back on the dashboard, tap <strong>Revisit</strong> on <strong>{reroute.sub_topic}</strong> for a quick recap.
            </p>
          )}
        </div>

        <div className="bg-amber-50 border border-amber-200 rounded-2xl px-5 py-3 mb-6 text-slate-700 text-sm text-center" data-testid="stop-unlock-hint">
          Ask your teacher to unlock this topic when you're ready to try Practice again.
        </div>

        <Button
          onClick={onContinue}
          className="rounded-full bg-amber-500 hover:bg-amber-600 text-white font-semibold px-8 py-6 tap-44"
          data-testid="stop-continue-btn"
        >
          <ArrowLeft className="w-5 h-5 mr-1" /> Back to Dashboard
        </Button>
      </Card>
    </div>
  );
}
